const latestByScope = new Map();

export const startRequest = (scope) => {
  const id = (latestByScope.get(scope) || 0) + 1;
  latestByScope.set(scope, id);
  return id;
};

export const isLatestRequest = (scope, id) => latestByScope.get(scope) === id;

export const resetRequestScopes = () => latestByScope.clear();
